module.exports = __webpack_public_path__ + "assets/img/2d3a2f39ac6d36d04bb69c4131defd5c.png";